import axios, { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'
import { StatusCode, status } from 'src/context/common'

interface IDataParams {
  fileName: string
  fileType: string
  studentCode?: string
}
interface IDataPayloadParams {
  fileName: string
  fileType: string
  programCode: string
}

export default class Common {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getYearList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.year
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Academic list ========>', err?.message)
    }
    nProgress.done()
  }
  async getNqfLevelList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.nqfLevel
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching nqfLevel list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getCategoriesList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.categories
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getStudyTypeList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.studymode
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getUploadDocumentUrl(payload: IDataParams): Promise<any> {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.fileUpload}?filename=${payload.fileName}&filetype=${
      payload.fileType
    }`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  uploadDocuments = async (uploadFileUrl: string, file: File) => {
    try {
      const response = await axios.put(uploadFileUrl, file)
      if (response.status === StatusCode?.Success) {
        return await response
      } else return await response
    } catch (error: any) {
      console.log(error.message)

      return await error
    }
  }
  async getCountryList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.country
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getDocumentDetails(fileName: string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.getDocument + fileName
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getFileUrl(fileName: string, studentCode: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.getDocument + fileName
    try {
      const response = await this.apiServer.get(`${endUrlName}&studentCode=${studentCode}`)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching student detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getAddressList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.addressList
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Address detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }

  async getGenderList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.gender
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Gender detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getNationalityList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.nationality
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Nationality detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getNationalityStatus() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.nationalityStatus
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Nationality  Status detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }

  async getIdentificationTypeList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.identificationType

    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error Fetching IdentificationType List ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getHighestQualification() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.qualification
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching student detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }

  async getRace() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.race
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Race detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getLanguage() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.language
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching language detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getUploadDocument(payload: IDataParams): Promise<any> {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.fileUpload}?filename=${payload.fileName}&filetype=${
      payload.fileType
    }&&studentCode=${payload?.studentCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getStatesByCountry(countryCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.stateByCountry}/${countryCode}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching State List By Country Code ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getStudyModeList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.studyModeList
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching study mode  detail ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getUploadDocumentUrlMaster(payload: IDataPayloadParams): Promise<any> {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.fileUploadMaster}?filename=${payload.fileName}&filetype=${
      payload.fileType
    }&programCode=${payload.programCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching categories list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getVenueList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.venueType
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching Venue detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getQueryType() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.queryType
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching query type ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getAuditLog(applicationCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.getAuditLog}/${applicationCode}/${status.local}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data
    } catch (err: any) {
      console.error('Error fetching Audit Logs ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getRelationShipData() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.relationShipData
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response?.data
    } catch (err: any) {
      console.log('Error fetching Venue detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getStudentStatus() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.studentStatus
    try {
      const response = await this.apiServer.get(endUrlName)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Student Status list ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }

  async getProjectDocumentTypeList() {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.documentTypeList}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data
    } catch (err: any) {
      console.log('Error Fetching Project Management Document Type List ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async documentUpload(param: any) {
    nProgress.start()
    let response = false
    const endUrlName = `${this.baseUrl + apiEndPoints.uploadFileUrl}?filename=${param.filename}&filetype=${
      param.filetype
    }&studentCode=${param.studentCode}`

    try {
      const s3amazonawsUrl = await this.apiServer.get(endUrlName)
      if (s3amazonawsUrl?.data?.statusCode === status.successCode) {
        const isFileUploaded = await axios.put(decodeURIComponent(s3amazonawsUrl.data.data), param?.file, {
          onUploadProgress: param?.setUploadPercent
        })
        response = isFileUploaded.status === status.successCode
      } else {
        return response
      }

      return response
    } catch (err: any) {
      console.log('Error in Upload Document to Amazon AWS S3 ========>', err?.message)
    } finally {
      nProgress.done()

      // eslint-disable-next-line no-unsafe-finally
      return response
    }
  }
  async DocumentCode() {
    nProgress.start()
    const url = `${this.baseUrl + apiEndPoints?.documentCode}`
    try {
      const response = await this.apiServer.get(url)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error getting document code ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getMenuConfig() {
    const isBrowser = typeof window !== 'undefined'
    if (isBrowser) nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.menuConfig
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching menu config ========>', err?.message)
    } finally {
      if (isBrowser) nProgress.done()
    }
  }
}
